<template>
  <div class="form-employment">
    <b-row>
      <b-col v-for="col in columnsTop" :key="col.field" md="4">
        <validation-observer :ref="`simpleRules${col.field}`">
          <validation-provider
            #default="{ errors }"
            :name="col.label"
            :rules="col.formOption ? col.formOption.rules : ''"
          >
            <div
              v-if="col.auditing"
              style="padding-left: 15px; display: inline-block"
            >
              <label :class="{ required: hasRequired(col.formOption) }"
                >{{ col.label }}:</label
              ><br />
              <b-badge
                v-b-tooltip.hover.focus.v-primary
                variant="primary"
                class="cursor-pointer"
                :title="
                  `${col.auditData.createStaff.realName}: ${col.auditData.createTime}`
                "
              >
                <span>
                  {{
                    col.auditData.oldDataName
                      ? col.auditData.oldDataName
                      : col.auditData.oldData
                  }}
                </span>
                <feather-icon icon="ArrowRightIcon" size="20" />
                <span class="text-warning">
                  {{
                    col.auditData.newDataName
                      ? col.auditData.newDataName
                      : col.auditData.newData
                  }}
                </span>
              </b-badge>
            </div>
            <div
              v-else-if="col.disabled || disabled"
              style="padding-left: 15px; display: inline-block"
            >
              <label :class="{ required: hasRequired(col.formOption) }"
                >{{ col.label }}:</label
              ><br />
              <p class="text-primary">
                {{ form[col.fieldDict ? col.fieldDict : col.field] }}
              </p>
            </div>
            <form-item
              v-else
              :form-label="col.label"
              :required="hasRequired(col.formOption)"
              :form-value="form[col.fieldDict ? col.fieldDict : col.field]"
              @saveFormItem="update($event, col.field)"
              @clearFormItem="clearFormItem(col.field)"
            >
              <template slot="labelSmall">
                <small class="text-danger">{{ errors[0] }}</small>
              </template>
              <element-component
                :id="`v-add-${col.field}`"
                v-model="reform[col.field]"
                :state="errors.length > 0 ? false : null"
                :label="col.label"
                :option="col"
                :disabled="col.disabled"
              />
            </form-item>
          </validation-provider>
        </validation-observer>
      </b-col>
    </b-row>
    <template v-if="deptColumns[0].auditing">
      <div class="mb-1" style="padding-left: 15px; display: inline-block;">
        <label :class="{ required: hasRequired(deptColumns[0].formOption) }"
          >{{ deptColumns[0].label }}:</label
        ><br />
        <b-badge
          v-b-tooltip.hover.focus.v-primary
          variant="primary"
          class="cursor-pointer"
          :title="
            `${deptColumns[0].auditData.createStaff.realName}: ${deptColumns[0].auditData.createTime}`
          "
        >
          <span>
            {{
              deptColumns[0].auditData.oldDataName
                ? deptColumns[0].auditData.oldDataName
                : deptColumns[0].auditData.oldData
            }}
          </span>
          <feather-icon icon="ArrowRightIcon" size="20" />
          <span class="text-warning">
            {{
              deptColumns[0].auditData.newDataName
                ? deptColumns[0].auditData.newDataName
                : deptColumns[0].auditData.newData
            }}
          </span>
        </b-badge>
      </div>
    </template>
    <form-item
      v-else
      :form-label="deptColumns.map((o) => o.label).join('-')"
      :required="true"
      :form-value="
        deptColumns
          .map((col) => form[col.fieldDict ? col.fieldDict : col.field])
          .join()
      "
      @saveFormItem="updateDept"
      @clearFormItem="clearFormItem(deptColumns.map((col) => col.field))"
    >
      <b-row>
        <b-col v-for="col in deptColumns" :key="col.field" md="4">
          <validation-observer :ref="`simpleRules${col.field}`">
            <validation-provider
              #default="{ errors }"
              :name="col.label"
              :rules="col.formOption ? col.formOption.rules : ''"
            >
              <div
                v-if="col.disabled || disabled"
                style="padding-left: 15px; display: inline-block"
              >
                <label :class="{ required: hasRequired(col.formOption) }"
                  >{{ col.label }}:</label
                ><br />
                <p class="text-primary">
                  {{ form[col.fieldDict ? col.fieldDict : col.field] }}
                </p>
              </div>
              <element-component
                v-else
                :id="`v-add-${col.field}`"
                v-model="form[col.field]"
                :state="errors.length > 0 ? false : null"
                :label="col.label"
                :option="col"
                :disabled="col.disabled"
              />
            </validation-provider>
          </validation-observer>
        </b-col>
      </b-row>
    </form-item>
    <div class="form-employment-line" />

    <b-row>
      <b-col v-for="col in columnsBottom" :key="col.field" md="4">
        <validation-observer :ref="`simpleRules${col.field}`">
          <validation-provider
            #default="{ errors }"
            :name="col.label"
            :rules="col.formOption ? col.formOption.rules : ''"
          >
            <div
              v-if="col.auditing"
              style="padding-left: 15px; display: inline-block"
            >
              <label :class="{ required: hasRequired(col.formOption) }"
                >{{ col.label }}:</label
              ><br />
              <b-badge
                v-b-tooltip.hover.focus.v-primary
                variant="primary"
                class="cursor-pointer"
                :title="
                  `${col.auditData.createStaff.realName}: ${col.auditData.createTime}`
                "
              >
                <span>
                  {{
                    col.auditData.oldDataName
                      ? col.auditData.oldDataName
                      : col.auditData.oldData
                  }}
                </span>
                <feather-icon icon="ArrowRightIcon" size="20" />
                <span class="text-warning">
                  {{
                    col.auditData.newDataName
                      ? col.auditData.newDataName
                      : col.auditData.newData
                  }}
                </span>
              </b-badge>
            </div>
            <div
              v-else-if="col.disabled || disabled"
              style="padding-left: 15px; display: inline-block"
            >
              <label :class="{ required: hasRequired(col.formOption) }"
                >{{ col.label }}:</label
              ><br />
              <p class="text-primary">
                {{ getValue(col) }}
              </p>
              <small class="text-primary">{{ col.small }}</small>
            </div>
            <!-- :form-value="form[col.fieldDict ? col.fieldDict : col.field]" -->
            <form-item
              v-else
              :required="hasRequired(col.formOption)"
              :form-label="col.label"
              :form-value="getValue(col)"
              :only-show="col.hideEdit"
              @saveFormItem="update($event, col.field)"
              @clearFormItem="clearFormItem(col.field)"
            >
              <template slot="labelSmall">
                <small class="text-danger">{{ errors[0] }}</small>
              </template>
              <div v-if="col.field == 'workWeek'">
                <div style="display: flex;gap: 16px;">
                  <el-select
                    style="width: 150px"
                    v-model="reform.workWeek"
                    slot="prepend"
                    filterable
                  >
                    <el-option
                      v-for="item in workWeekOptions"
                      :key="item.dictKey"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    style="width: 150px"
                    v-model="reform.shift"
                    slot="prepend"
                    filterable
                  >
                    <el-option
                      v-for="item in staffShiftOptions"
                      :key="item.dictKey"
                      :label="item.dictValue"
                      :value="Number(item.dictKey)"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div v-else>
                <element-component
                  :id="`v-add-${col.field}`"
                  v-model="reform[col.field]"
                  :state="errors.length > 0 ? false : null"
                  :label="col.label"
                  :option="col"
                  :disabled="col.disabled"
                />
              </div>
            </form-item>
          </validation-provider>
        </validation-observer>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ElementComponent from '@/components/elementComponent.vue'
import FormItem from '@/components/FormItem.vue'
import { employment } from '@/api/staff/index'
import { BFormInput, BCol, BRow, BBadge, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { deepClone } from '@/util/util'
import { getDictionaryByBiz } from '@/api/system/dict'
export default {
  components: {
    FormItem,
    BCol,
    BRow,
    ElementComponent,
    ValidationProvider,
    ValidationObserver,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    // 修改刷新的回调
    refreshChange: {
      type: Function,
      default: (done) => {
        done()
      },
    },
    auditData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 需要number转string的类型
      hasToStringTypes: ['select'],
      reform: {},
      workWeekOptions: [],
      staffShiftOptions: [],
    }
  },
  computed: {
    columnsTop() {
      const columns = [
        {
          label: this.i18n('labelEmployment.staffNo'),
          field: 'staffNo',
          formOption: {
            rules: 'required',
          },
          disabled: true,
        },
        // {
        //   label: this.i18n('labelEmployment.grade'),
        //   field: 'grade',
        //   fieldDict: 'gradeName',
        //   type: 'select',
        //   dictBizCode: 'Level',
        // },
        {
          label: 'Category',
          field: 'category',
          fieldDict: 'categoryName',
          type: 'select',
          dictBizCode: 'staff_category',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: 'UEN',
          field: 'signCompany',
          type: 'select',
          fieldDict: 'uen',
          dictCode: 'uenCompany',
          formOption: {
            rules: 'required',
          },
        },
        // {
        //   label: this.i18n('labelEmployment.companyId'),
        //   field: 'companyId',
        //   type: 'select',
        //   fieldDict: 'companyName',
        //   dictCode: 'company',
        //   formOption: {
        //     rules: 'required',
        //   },
        // },
        {
          label: this.i18n('labelEmployment.postId'),
          field: 'postId',
          fieldDict: 'postName',
          type: 'select',
          dictCode: 'post',
          dictQuery: {
            category: '1',
            deptId: this.data.deptId,
          },
          disabled: !this.data.companyId,
          formOption: {
            type: 'select',
            dictCode: 'post',
          },
        },
        {
          label: this.i18n('labelEmployment.chinaCode'),
          field: 'chinaCode',
          fieldDict: 'chinaCodeName',
          type: 'select',
          dictBizCode: 'china_code',
        },
        {
          label: this.i18n('labelEmployment.babelLink'),
          field: 'babelLink',
        },
      ]
      const result = []
      columns.forEach((col) => {
        const param = col
        if (Array.isArray(this.auditData)) {
          this.auditData.forEach((item) => {
            if (col.field === item.field) {
              param.auditing = true
              param.auditData = item
            }
          })
        }
        result.push(param)
      })
      return result
    },
    columnsBottom() {
      const columns = [
        {
          label: this.i18n('labelEmployment.joinDate'),
          field: 'joinDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.jobTitle'),
          field: 'jobTitle',
          fieldDict: 'jobTitleName',
          type: 'select',
          dictBizCode: 'job_title',
        },
        {
          label: this.i18n('labelEmployment.wpNumber'),
          field: 'wpNumber',
        },
        {
          label: this.i18n('labelEmployment.wpExpiryDate'),
          field: 'wpExpiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.wpLastUpdateDate'),
          field: 'wpLastUpdateDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.wpIssueDate'),
          field: 'wpIssueDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.level'),
          field: 'level',
          type: 'select',
          fieldDict: 'levelName',
          dictBizCode: 'Level',
        },
        {
          label: this.i18n('labelEmployment.contractIssueDate'),
          field: 'contractIssueDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.contractLastUpdateDate'),
          field: 'contractLastUpdateDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.contractPeriodDate'),
          field: 'contractPeriodDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.entrySource'),
          field: 'entrySource',
          type: 'select',
          fieldDict: 'entrySourceName',
          dictBizCode: 'staff_entry_source',
        },
        // 新增字段
        {
          label: this.i18n('labelEmployment.workPermitNo'),
          field: 'workPermitNo',
        },
        {
          label: this.i18n('labelEmployment.workPermitLssue'),
          field: 'workPermitLssue',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.workPermitExpiry'),
          field: 'workPermitExpiry',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.csocBcss'),
          field: 'csocBcss',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.cpfFwl'),
          field: 'cpfFwl',
          // type: 'select',
          // fieldDict: 'cpfFwlName',
          // dictBizCode: 'cpf_fwl',
        },
        {
          label: this.i18n('labelEmployment.employerCpfUen'),
          field: 'employerCpfUen',
          disabled: true,
        },
        {
          label: this.i18n('labelEmployment.bcaCode'),
          field: 'bcaCode',
          type: 'select',
          fieldDict: 'bcaCodeName',
          dictBizCode: 'bca_code',
        },
        {
          label: this.i18n('labelEmployment.bankName'),
          field: 'bankName',
          fieldDict: 'bankNameName',
          dictBizCode: 'bank_name',
          type: 'select',
        },
        {
          label: this.i18n('labelEmployment.bankCode'),
          field: 'bankCode',
        },
        {
          label: this.i18n('labelEmployment.bankAccNo'),
          field: 'bankAccNo',
        },
        {
          label: this.i18n('labelEmployment.workWeek'),
          field: 'workWeek',
          type: 'select',
          fieldDict: 'workWeekName',
          dictBizCode: 'work_week',
        },
        {
          label: 'Type of Work',
          field: 'workType',
          type: 'select',
          fieldDict: 'workTypeName',
          dictBizCode: 'staff_work_type',
        },
        {
          label: this.i18n('labelEmployment.employmentNoticePeriod'),
          field: 'employmentNoticePeriod',
          type: 'select',
          fieldDict: 'employmentNoticePeriodName',
          dictBizCode: 'employment_notice_period',
        },
        {
          label: this.i18n('labelEmployment.officeLocation'),
          field: 'officeLocation',
          type: 'select',
          fieldDict: 'officeLocationName',
          dictBizCode: 'staff_office_location',
        },
        {
          label: this.i18n('labelEmployment.confirmationDate'),
          field: 'confirmationDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.quitDate'),
          field: 'quitDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
        },
        {
          label: this.i18n('labelEmployment.goalSetting'),
          field: 'goalSetting',
        },
        {
          label: this.i18n('labelEmployment.workTime'),
          field: 'workTime',
          type: 'select',
          fieldDict: 'workTimeName',
          dictBizCode: 'staff_work_time',
        },
      ]
      const result = []
      columns.forEach((col) => {
        const param = col
        if (Array.isArray(this.auditData)) {
          this.auditData.forEach((item) => {
            if (col.field === item.field) {
              param.auditing = true
              param.auditData = item
            }
          })
        }
        result.push(param)
      })
      return result
    },
    deptColumns() {
      const columns = [
        {
          label: this.i18n('labelEmployment.businessSection'),
          field: 'businessSectionId',
          fieldDict: 'businessSectionName',
          type: 'select',
          dictCode: 'deptBusinessSection',
          dictQuery: {
            parentId: this.data.companyId,
          },
          disabled: !this.data.companyId,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.deptId'),
          field: 'deptId',
          fieldDict: 'deptName',
          type: 'select',
          dictCode: 'dept',
          dictQuery: {
            parentId: this.data.companyId,
          },
          disabled: !this.data.companyId,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.i18n('labelEmployment.team'),
          field: 'teamId',
          fieldDict: 'teamName',
          type: 'select',
          dictCode: 'team',
          onlySelectChildren: true,
          dictQuery: {
            parentId: this.data.deptId,
          },
          disabled: !this.data.deptId,
        },
      ]
      const result = []
      columns.forEach((col) => {
        const param = col
        if (Array.isArray(this.auditData)) {
          this.auditData.forEach((item) => {
            if (item.field.split(',').indexOf(col.field) !== -1) {
              param.auditing = true
              param.auditData = item
            }
          })
        }
        result.push(param)
      })
      return result
    },
    form() {
      const res = this.data
      const cols = [this.columnsTop, this.columnsBottom]
      for (let i = 0; i < cols.length; i += 1) {
        const element = cols[i]
        element.forEach((item) => {
          const val = res[item.field]
          if (val || val === 0) {
            const formatVal =
              this.hasToStringTypes.indexOf(item.type) !== -1
                ? val.toString()
                : val
            res[item.field] = formatVal
          }
        })
      }
      return res
    },
  },
  mounted() {
    console.log('sddd mu=ouneeeeeeeeeee')
    this.getDictionaryList('work_week', 'workWeekOptions')
    this.getDictionaryList('staff_shift', 'staffShiftOptions')
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(e) {
        this.reform = deepClone(e)
      },
    },
  },
  methods: {
    // 国际化
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    getDictionaryList(code, name) {
      getDictionaryByBiz({ code }).then((res) => {
        this[name] = res.data.data
      })
    },
    update(done, key) {
      this.$refs[`simpleRules${key}`][0].validate().then((success) => {
        if (success) {
          if (
            !this.reform.workWeek || this.reform.shift == 0
              ? false
              : !this.reform.shift
          ) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Please select work week and work shift `,
                icon: 'BellIcon',
                text: this.$t('_default.toast.text.success'),
                variant: 'error',
              },
            })
            return
          }
          if (key === 'workWeek') {
            const req1 = employment.update(
              { id: this.form.id, workWeek: this.reform.workWeek },
              { key: 'workWeek' }
            )
            const req2 = employment.update(
              { id: this.form.id, shift: this.reform.shift },
              { key: 'shift' }
            )
            Promise.all([req1, req2]).then(() => {
              let isDone = false
              const refreshDone = () => {
                if (!isDone) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.$t('_default.toast.title'),
                      icon: 'BellIcon',
                      text: this.$t('_default.toast.text.success'),
                      variant: 'success',
                    },
                  })
                  done()
                  isDone = true
                }
              }
              this.refreshChange(refreshDone)
            })
            //如果是workWeek 需要同步修改shift
          } else {
            const params = { id: this.form.id }
            params[key] = this.reform[key] || ''
            employment.update(params, { key }).then((res) => {
              let isDone = false
              const refreshDone = () => {
                if (!isDone) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.$t('_default.toast.title'),
                      icon: 'BellIcon',
                      text: this.$t('_default.toast.text.success'),
                      variant: 'success',
                    },
                  })
                  done()
                  isDone = true
                }
              }
              this.refreshChange(refreshDone)
            })
          }
        }
      })
    },
    updateDept(done) {
      const params = { id: this.form.id }
      const keys = []
      this.deptColumns.forEach((item) => {
        params[item.field] = this.form[item.field]
        keys.push(item.field)
      })
      employment.update(params, { key: keys.join() }).then((res) => {
        let isDone = false
        const refreshDone = () => {
          if (!isDone) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.$t('_default.toast.text.success'),
                variant: 'success',
              },
            })
            done()
            isDone = true
          }
        }
        this.refreshChange(refreshDone)
      })
      console.log(params, keys)
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
    getValue(col) {
      // :form-value="form[col.fieldDict ? col.fieldDict : col.field]"
      if (col.field === 'workWeek') {
        return `${this.form.workWeekName} ${this.form.shiftName || ''}`
      }
      return this.form[col.fieldDict ? col.fieldDict : col.field]
    },
    clearFormItem(key) {
      if (Array.isArray(key)) {
        key.forEach((k) => {
          this.reform[k] = deepClone(this.form[k])
        })
        return
      }
      this.reform[key] = deepClone(this.form[key])
    },
  },
}
</script>

<style lang="scss" scoped>
.form-employment {
  &-line {
    width: 100%;
    border-bottom: 1px solid #cad6eb;
    margin-bottom: 1rem;
  }
  &-body {
    display: flex;
    &__left {
      width: 68%;
    }
    &__right {
      width: 32%;
      position: relative;
    }
  }
}
</style>
